var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#635FC7",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 9,
    width: 6,
    height: 25,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 18,
    width: 6,
    height: 25,
    rx: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo-mobile.e60c2fbc3dcefa4256e0569ffba5e523.svg";
export { ForwardRef as ReactComponent };